import { render, staticRenderFns } from "./detailFileUpload.vue?vue&type=template&id=2c6a5b01&scoped=true&"
import script from "./detailFileUpload.vue?vue&type=script&lang=js&"
export * from "./detailFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./detailFileUpload.vue?vue&type=style&index=0&id=2c6a5b01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a5b01",
  null
  
)

export default component.exports